(function($) {

    var mainNav = $("#main-navigation");
    var menuItemHasMega = $(".nav-link.open-megamenu");
    var btnCloseMegamenu = $(".megamenu__close-btn");

    var btnOpenSubmenu = $(".megamenu .open-submenu");

// Ouverture du mega menu
    menuItemHasMega.click(function(event) {
        event.preventDefault();

        $(".nav-link.open-megamenu").removeClass("open-megamenu--is-opened");
        $(".megamenu").removeClass("megamenu--opened");

        var megaMenu = $(this).next(".megamenu");

        $(this).addClass("open-megamenu--is-opened");
        megaMenu.addClass("megamenu--opened");
        mainNav.addClass("main-nav--megamenu-opened");

        $('.main-nav--megamenu-opened>.navbar-nav>.nav-item>.nav-link:not(.open-megamenu--is-opened)').attr("tabIndex", "-1");
    });

// Fermeture du megamenu
    btnCloseMegamenu.click(function(event) {

        $(this).parents(".megamenu").prev(".nav-link.open-megamenu").removeClass("open-megamenu--is-opened");
        $(this).parents(".megamenu").removeClass("megamenu--opened");
        mainNav.removeClass("main-nav--megamenu-opened");

        $('.main-nav>.navbar-nav>.nav-item>.nav-link:not(.open-megamenu--is-opened)').removeAttr('tabIndex');
    });

// Ouverture Menu de 3ème niveau
    btnOpenSubmenu.click(function(event) {

        $(this).toggleClass("open-submenu--opened");

        if($(this).attr("aria-expanded") === "true") {
            $(this).attr("aria-expanded", "false")
        } else {
            $(this).attr("aria-expanded", "true")
        }

        var subNav = $(this).next(".subnav");

        subNav.toggleClass("subnav--opened");
    })
})(jQuery);
